<template>
	<v-dialog
		v-model="open"
		max-width="700"
		@click:outside="$emit('close')"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		:scrollable="false"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品見積依頼詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="$emit('close')" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-sheet elevation="0" class="mt-4">
					<h3 class="heading">基本情報</h3>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">見積種類</th>
								<td width="70%">
									<p v-if="quote_request.component_quotes.length">
										{{ quote_request.component_quotes[0].quotation_type | quotationTypeFormatter }}
									</p>
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">見積番号</th>
								<td width="70%">{{ quote_request.quote_number }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信先企業</th>
								<td width="70%">{{ quote_request.supplier.name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信日時</th>
								<td width="70%">
									{{ quote_request.created_at | datetimeFormatter }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信者</th>
								<td width="70%">{{ quote_request.user.full_name }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信タイトル</th>
								<td width="70%">
									<p v-if="quote_request.mail_infos.length">
										{{ quote_request.mail_infos[0].title }}
									</p>
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">送信内容</th>
								<td width="70%">
									<p v-html="mailContent"></p>
								</td>
							</tr>
						</tbody>
					</table>
					<h3 class="heading">見積部品情報</h3>
					<table
						width="100%"
						class="show-dialog-table"
						v-for="component_quote in quote_request.component_quotes"
						:key="component_quote.id"
					>
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">製造番号</th>
								<td width="70%">
									<p>
										{{
											component_quote.ordered_product
												? component_quote.ordered_product.product_number
												: "未受注製品"
										}}
									</p>
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">見積部品名</th>
								<td>
									<div v-if="component_quote.order_component">
										<p>{{ component_quote.order_component.component.name }}</p>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	filters: {
		datetimeFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD HH:mm")
			}
		},
		quotationTypeFormatter(item) {
			switch (item) {
				case "ordered":
					return "受注"
					break
				case "yet":
					return "未受注"
					break
			}
		},
	},
	props: {
		quote_request: {
			title: {
				type: Object,
				default: () => {},
			},
		},
	},
	data() {
		return {
			open: true,
		}
	},
	methods: {
		replaceUrlWithLink(url) {
			return `<a href="${url}" target="_blank">${url}</a>`
		},
	},
	computed: {
		mailContent() {
			if (this.quote_request.mail_infos.length) {
				const urlPattern = /((http|https):\/\/[^\s]+)/g
				const linkedContent = this.quote_request.mail_infos[0].content.replace(
					urlPattern,
					this.replaceUrlWithLink
				)
				return linkedContent
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

p {
	white-space: pre-line;
	word-break: break-all;
}
h3.heading {
	font-size: 105%;
	font-weight: bold;
	color: white;
	background: $main-color;
	margin: 32px 0 0 0;
	padding: 8px;
}
</style>
